/*
  Pins the section (via CSS position: sticky - a single tall wrapper here,
  unlike collection-tabs-sticky.js, so sticky positioning already has a
  proper containing block to stick within) while the user scrolls through
  it, crossfading from the first heading to the second heading + body copy
  partway through, then releasing back into normal flow once the wrapper's
  extra scroll height is used up.
*/
(function () {
  const sections = document.querySelectorAll('.sticky-reveal');
  if (!sections.length) return;

  const state = [];

  function update() {
    for (const entry of state) {
      const rect = entry.wrapper.getBoundingClientRect();
      const scrollable = rect.height - window.innerHeight;
      const progress = scrollable > 0 ? (0 - rect.top) / scrollable : 0;
      const clamped = Math.min(1, Math.max(0, progress));
      const showSecond = clamped >= 0.5;

      if (showSecond !== entry.showingSecond) {
        entry.screenOne.classList.toggle('is-active', !showSecond);
        entry.screenTwo.classList.toggle('is-active', showSecond);
        entry.showingSecond = showSecond;
      }
    }
  }

  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  }

  sections.forEach((wrapper) => {
    const screenOne = wrapper.querySelector('[data-screen="1"]');
    const screenTwo = wrapper.querySelector('[data-screen="2"]');
    if (!screenOne || !screenTwo) return;
    state.push({ wrapper, screenOne, screenTwo, showingSecond: false });
  });

  // On desktop (>= 990px) Horizon makes .page-wrapper the actual scrolling
  // container (overflow-y: auto), not the window - window scroll events
  // never fire there. On mobile .page-wrapper doesn't scroll internally, so
  // window is the one that fires. Listening on both covers both cases (see
  // assets/collection-tabs-sticky.js for the same pattern).
  const pageWrapper = document.querySelector('.page-wrapper');

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }

  update();
})();
